import React, { Component } from 'react';
import {
  Map, Polygon, GoogleApiWrapper,
} from 'google-maps-react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

class MapComponent extends Component {
  constructor(props) {
    super(props);
  }

  calculateCenter = (coordinates) => {
    let minLat = coordinates[0].lat;
    let maxLat = coordinates[0].lat;
    let minLng = coordinates[0].lng;
    let maxLng = coordinates[0].lng;
    for (let index in coordinates) {
      if (coordinates[index].lat < minLat) {
        minLat = coordinates[index].lat;
      } else if (coordinates[index].lat > maxLat) {
        maxLat = coordinates[index].lat;
      }
      if (coordinates[index].lng < minLng) {
        minLng = coordinates[index].lng;
      } else if (coordinates[index].lng > maxLng) {
        maxLng = coordinates[index].lng;
      }
    }
    let avgLat = (minLat + maxLat) / 2;
    let avgLng = (minLng + maxLng) / 2;
    let center = { lat: avgLat, lng: avgLng };
    center.lat = Number(center.lat.toFixed(5));
    center.lng = Number(center.lng.toFixed(5));
    return center;
  }

  calculateZoom(coordinates) {
    //   let minLat = coordinates[0].lat;
    //   let maxLat = coordinates[0].lat;
    //   let minLng = coordinates[0].lng;
    //   let maxLng = coordinates[0].lng;
    //   for (let index in coordinates) {
    //     if (coordinates[index].lat < minLat) {
    //       minLat = coordinates[index].lat;
    //     } else if (coordinates[index].lat > maxLat) {
    //       maxLat = coordinates[index].lat;
    //     }
    //     if (coordinates[index].lng < minLng) {
    //       minLng = coordinates[index].lng;
    //     } else if (coordinates[index].lng > maxLng) {
    //       maxLng = coordinates[index].lng;
    //     }
    //   }
    //   let height = maxLat - minLat;
    //   let width = maxLng - minLng;
    //   let size = Math.max(height, width);
    // calculate zoom based on size to improve customer experience
    return 11;
  }

  render() {
    const {
      locations, match, rowNumber,
    } = this.props;
    const { resourceId, subResource } = match.params;
    let zonesData = (locations && locations.length > 0) ? (locations.filter(loc => loc.id == resourceId)[0][subResource]) : [];
    zonesData = zonesData || [];

    // create an array of coordinate objects
    let coordinateArray = [];
    if (zonesData[rowNumber]) {
      let coordinateString = Object.values(zonesData[rowNumber])[2];
      coordinateArray = coordinateString.split(',');
      for (let index in coordinateArray) {
        let prefix = coordinateArray[index].slice(0, 3);
        if (prefix === '0.0') {
          coordinateArray[index] = coordinateArray[index].substring(4);
        } else if (coordinateArray[index][0] === '0') {
          coordinateArray[index] = coordinateArray[index].substring(2);
        }
      }
      // if array length is odd, remove element at end of array
      if (coordinateArray.length % 2 !== 0) {
        let emptyString = coordinateArray.splice(-1, 1);
      }
    }
    let coordinates = [];
    for (let i = 0; i < coordinateArray.length / 2; i++) {
      let latLng = { lat: Number(Number(coordinateArray[i * 2 + 1]).toFixed(3)), lng: Number(Number(coordinateArray[i * 2]).toFixed(3)) };
      coordinates.push(latLng);
    }

    return (
      <div style={{ height: '400px', position: 'relative' }}>
        <Map
          google={this.props.google}
          initialCenter={this.calculateCenter(coordinates)}
          style={{ width: '500px', height: '350px', position: 'relative' }}
          className="map"
          zoom={this.calculateZoom(coordinates)}
        >
          <Polygon
            paths={coordinates}
            strokeColor="#0000FF"
            StrokeOpacity={0.8}
            strokeWeight={2}
            fillColor="#0000FF"
            fillOpacity={0.35}
          />
        </Map>
      </div>

    );
  }
}

MapComponent.propTypes = {
  coordinates: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any).isRequired),
};

export default withStyles({})(GoogleApiWrapper({
  apiKey: ('AIzaSyBQ8Oa08f13_hY8Z1tuQp3VPx9tDCaY2O4'),
})(MapComponent));
